package com.macrofocus.eflux.ui.morphing

import org.locationtech.jts.geom.Coordinate
import org.locationtech.jts.geom.GeometryFactory
import org.locationtech.jts.geom.LinearRing
import org.locationtech.jts.geom.Polygon

fun adjustPolygonOrientation(polygon: Polygon, makeCounterClockwise: Boolean = true): Polygon {
    val result = adjustPolygonOrientation(polygon.exteriorRing!!, makeCounterClockwise)
    return polygon.factory.createPolygon(result)
}

fun adjustPolygonOrientation(polygon: LinearRing, makeCounterClockwise: Boolean = true): LinearRing {
    val result = adjustPolygonOrientation(polygon.coordinates, makeCounterClockwise)
    return polygon.factory.createLinearRing(result)
}

// Check if polygon is clockwise and optionally invert it
fun adjustPolygonOrientation(coordinates: Array<Coordinate>, makeCounterClockwise: Boolean = true): Array<Coordinate> {
    val geometryFactory = GeometryFactory()

    // Ensure the polygon is closed
    val closedCoords = if (coordinates[0] == coordinates.last()) {
        coordinates
    } else {
        coordinates + coordinates[0]
    }

    // Create a LinearRing to compute signed area
    val ring = geometryFactory.createLinearRing(closedCoords)
    val isClockwise = ring.isClockwise()

    // If current orientation matches desired orientation, return as-is
    return if (isClockwise == makeCounterClockwise) {
        // Orientation needs to flip
        val reversedCoords = closedCoords.reversedArray().dropLast(1).toTypedArray() + closedCoords[0]
        reversedCoords
    } else {
        closedCoords
    }
}

fun Polygon.isClockwise(): Boolean {
    return exteriorRing!!.signedArea() < 0
}

fun LinearRing.isClockwise(): Boolean {
    return signedArea() < 0
}

// Helper extension property to compute signed area
fun LinearRing.signedArea(): Double {
    val coords = this.coordinates
    var sum = 0.0
    for (i in 0 until coords.size - 1) {
        val p1 = coords[i]
        val p2 = coords[i + 1]
        sum += (p1.x * p2.y) - (p2.x * p1.y)
    }
    return sum / 2.0
}

//fun main() {
//    val geometryFactory = GeometryFactory()
//
//    // Example: Clockwise polygon (square)
//    val cwCoords = arrayOf(
//        Coordinate(0.0, 0.0),
//        Coordinate(1.0, 0.0),
//        Coordinate(1.0, 1.0),
//        Coordinate(0.0, 1.0),
//        Coordinate(0.0, 0.0) // Closed
//    )
//
//    // Invert to counterclockwise
//    val ccwCoords = adjustPolygonOrientation(cwCoords, makeCounterClockwise = true)
//    val ccwRing = geometryFactory.createLinearRing(ccwCoords)
//    println("Original clockwise: ${cwCoords.joinToString { "(${it.x}, ${it.y})" }}")
//    println("Adjusted to counterclockwise: ${ccwCoords.joinToString { "(${it.x}, ${it.y})" }}")
//    println("Is now counterclockwise: ${ccwRing.signedArea() > 0}") // Should be true
//
//    // Example: Counterclockwise polygon (square)
//    val ccwInput = arrayOf(
//        Coordinate(0.0, 0.0),
//        Coordinate(0.0, 1.0),
//        Coordinate(1.0, 1.0),
//        Coordinate(1.0, 0.0),
//        Coordinate(0.0, 0.0) // Closed
//    )
//
//    // Invert to clockwise
//    val cwAdjusted = adjustPolygonOrientation(ccwInput, makeCounterClockwise = false)
//    val cwRing = geometryFactory.createLinearRing(cwAdjusted)
//    println("\nOriginal counterclockwise: ${ccwInput.joinToString { "(${it.x}, ${it.y})" }}")
//    println("Adjusted to clockwise: ${cwAdjusted.joinToString { "(${it.x}, ${it.y})" }}")
//    println("Is now clockwise: ${cwRing.signedArea() < 0}") // Should be true
//}